import { healthInsurancePoints } from "./data";
import Image from "next/image";
import en from "../../../public/locale/en"; // Import your language files
import hi from "../../../public/locale/hi";
import ta from "../../../public/locale/ta";
import { useRouter } from "next/router";

export const StatsBanner = () => {
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : locale === "hi" ? hi : ta;

  return (
    <div>
      <div className="flex lg:flex-row flex-col gap-10">
        <div className="flex-1">
          <h2 className="font-medium md:text-3xl xd:text-2xl text-xl">
            {t["Why Choose Niva Bupa?"]}
          </h2>
          <div className="font-light md:text-xl xs:text-lg text-base mt-6">
            {
              t[
                "Niva Bupa strives to give every Indian the confidence to access the best health care. Niva Bupa is the right choice if you're looking for a reliable health insurance company in India. Trusted by over 1.2 crore+ happy customers, we offer a diverse range of health insurance plans that cater to different requirements and budgets."
              ]
            }
            {/* You can add translations for the commented text here */}
          </div>
        </div>
        <div className="flex-1">
          <h5 className="xs:text-xl text-lg w-[12rem] infoFrlangTitle-ab">
            {t["Our Success in Enriching Lives"]}
          </h5>
          <div className="text-white px-3 p-4 border-2 border-dotted border-neutral-400 rounded-lg relative w-[65%] h-[15rem] after:absolute after:bottom-12 after:right-[-100px] sm:after:right-[-120px] after:h-0 after:w-0 after:border-x-[22px] after:border-x-transparent after:border-b-[40px] after:border-b-orange-500 after:rotate-45 infoFrlang-ab">
            <div className="p-4 rounded-tr-3xl rounded-bl-3xl bg-[#016EBA] w-[6rem] sm:w-[12rem] h-auto sm:h-[10rem]  infoFrlang-sub1-ab">
              <div className="text-xs sm:text-base">
                {t["Cashless Claim Processing"]}
              </div>
              <div className="text-lg sm:text-3xl">30 mins</div>
              <div className="text-xs sm:text-base">
                Cashless Claim Processing<sup>1</sup>
              </div>
            </div>
            <div className="p-4 rounded-tr-3xl rounded-bl-3xl bg-[#2891DB] absolute md:right-[-4rem] -right-20 sm:right-[-6rem] xs:top-[-3rem] top-0 w-[8rem] sm:w-[10rem]  infoFrlang-sub2-ab">
              <p className="text-md sm:text-2xl">1.4 crore+</p>
              <div className="text-xs sm:text-base">
                {/* {t["Our happy customers**"]} */}
                Happy customers served till date
              </div>
            </div>
            <div className="p-4 rounded-tl-3xl rounded-br-3xl bg-[#00B0F6] absolute right-[-3rem] top-[45%] w-[6rem] sm:w-[10rem] infoFrlang-sub3-ab">
              <div className="text-lg sm:text-3xl">15 lakh+</div>
              <div className="text-xs sm:text-base">
                {/* {t["A strong network of hospitals***"]} */}
                Claims paid since inception<sup>2</sup>
              </div>
            </div>
            <div className="absolute bottom-0 translate-y-1/2 left-1/2 h-[50px] w-[50px] bg-orange-600 rounded-full" />
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-4 py-12 mt-8 justify-center relative bg-white xs:w-auto w-[250px]">
        <div className="absolute w-[160px] h-[78px] top-8 left-20 dottedBackground" />
        <div className="shadow-[0_0_10px_-4px_gray] rounded-2xl py-4 px-8 w-[20rem] z-0 bg-white">
          <Image
            src="/aem-to-react/icons/Robust_ic.png"
            sizes="100vw"
            height={0}
            width={0}
            alt="Home page Background photo"
            title="Home page Background photo"
            className="w-12 h-12"
          />
          <p className="xs:text-xl text-lg mt-4">
            {t["Digital solutions that cater to your medical needs"]}
          </p>
        </div>
        <div className="shadow-[0_0_10px_-4px_gray] rounded-2xl py-4 px-8 w-[20rem] z-0 bg-white">
          <Image
            src="/aem-to-react/icons/Claim_ic.png"
            sizes="100vw"
            height={0}
            width={0}
            alt="Home page Background photo"
            title="Home page Background photo"
            className="w-12 h-12"
          />
          <p className="xs:text-xl text-lg  mt-4">
            {t["All claims processed directly. No third party involved"]}
          </p>
        </div>
      </div>
    </div>
  );
};

export const HealthInsuranceBanner = () => {
  return (
    <div className="flex flex-col lg:flex-row gap-10">
      <div className="flex-1">
        <div>
          <h3 className="font-medium md:text-3xl text-xl">
            &quot;Why do I need health insurance?&quot;
          </h3>
        </div>
        <div className="flex flex-row mt-8 gap-6">
          <div className="hidden md:block">
            <div className="w-[211px] h-[200px] relative">
              <Image
                src={"/svgs/get-quote/health-insurance-lock.svg"}
                fill
                style={{ backgroundSize: "cover" }}
                alt="health insurance"
                height={0}
                width={0}
              />
            </div>
            <div
              style={{
                background:
                  "linear-gradient(90deg,#F2F2F2 5px,transparent 1%) center,linear-gradient(#F2F2F2 5px,transparent 1%) center,#0093e8",
                backgroundSize: "7px 7px",
                width: "100%",
                height: "50px",
              }}
            />
          </div>
          <div className="flex flex-col gap-6">
            <div className="font-medium md:text-lg text-base">
              Here are four reasons why you should consider buying a health
              insurance policy for yourself and your family.
            </div>
            <div className="font-light md:text-xl text-base">
              Beyond saving on medical expenses, there are multiple reasons why
              you should get insured. In fact, it is advisable that you buy a
              policy while you are still healthy and young.
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 flex-1">
        {healthInsurancePoints.map((point, index) => (
          <div
            key={index}
            className="flex flex-row gap-4 py-2 px-4 bg-white w-full items-center max-w-xl"
            style={{
              boxShadow: " 0px 4px 12px rgba(0, 0, 0, 0.123134)",
              borderRadius: "5px 5px 12px 12px",
            }}
          >
            <div>{point.image}</div>
            <span className="md:text-lg text-base">{point.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const InfoBanner = () => {
  return (
    <>
      <div>
        <StatsBanner />
      </div>
      <div className="mt-10">
        <HealthInsuranceBanner />
      </div>
    </>
  );
};

export default InfoBanner;
